<div class="col-12 text-center mt-4 mt-md-5">
    <ul class="pagination justify-content-center mb-0">
        <li class="page-item">
            <a class="page-link" [routerLink]="" (click)="onPrevClicked()">Prev</a>
        </li>
        <li class="page-item" [ngClass]="{active: pagenumber.selected === true}" aria-current="page" *ngFor="let pagenumber of pageNumbers">
            <div *ngIf="pagenumber.selected === true">
                <span class="page-link">{{pagenumber.number}}</span>
                <span class="sr-only" *ngIf="pagenumber.selected">(current)</span>
            </div>
            <div *ngIf="pagenumber.selected === false">
                <a class="page-link" [routerLink]="" (click)="onPageNumberClicked(pagenumber)">{{pagenumber.number}}</a>
            </div>
        </li>
        <li class="page-item">
            <a class="page-link" [routerLink]="" (click)="onNextClicked()">Next</a>
        </li>
    </ul>
</div>